// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import dataTableStyles from "@pace/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

userListUsersTableStyles.usernameCells = {
    css: css`
        font-weight: ${fontConfig.weight.regular};
        ${xScreen("lt", "sm")} {
            max-width: 210px;
            span {
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 200px;
            }
        }
    `,
};

userListUsersTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

userListUsersTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

userListUsersTableStyles.usernameCells = {
    css: css`
        ${TypographyStyle} {
            font-size: 14px;
            font-weight: ${fontConfig.weight.bold};
            letter-spacing: 0;
            line-height: 22px;
        }
    `,
};

userListUsersTableStyles.roleCells = {
    css: css`
        word-break: normal;
        white-space: normal;
    `,
};
